import { calendarNotificationHelper } from "../../calendar-common/helpers/calendarNotificationHelper";
import { enabledCalendarNotifications } from "../../calendar-common/helpers/calendar";
import { notifySubscriptions } from "../../calendar-common/helpers/notifySubscriptionHelper";
import { oneSignalInit } from "../../calendar-common/helpers/oneSignalHelper";
import { showPermissionAlert } from "./modalActions";
import {showEventNotifyModal} from "./eventNotifyActions";

const eventNotificationsReceived = (store, eventIds) => {
    store.setState({
        eventNotifications: eventIds,
    });
};

const getEventNotifications = (store, helper) => {
    helper.isPushNotificationsEnabled().then((isEnabled) => {
        if (isEnabled) {
            helper
                .getSubscriptions()
                .then((eventIds) =>
                    eventNotificationsReceived(store, eventIds)
                );
        }
    });
};

const subscriptionChangedListener = (store) => {
    const { config } = store.getState();
    if (config.subscriptionChangedEventName) {
        document.addEventListener(
            config.subscriptionChangedEventName,
            function (e) {
                eventNotificationsReceived(store, e.detail);
            },
            false
        );
    }
};

const enabledNotifications = (store) => {
    const { config } = store.getState();

    return enabledCalendarNotifications(config);
};

const getHelper = (store) => {
    const { config } = store.getState();

    const helper = config.notificationsHelper || calendarNotificationHelper;
    if (typeof helper === 'function')
        return helper();

    return new Promise(function (resolve, reject){ reject("Error getting notificationsHelper");});
};

const initOneSignal = (store) => {
    const { config } = store.getState();

    oneSignalInit(config);
};

export const initEventNotifications = (store) => {
    if (!enabledNotifications(store)) return;

    initOneSignal(store);

    getHelper(store)
        .then((helper) => {
            helper.isPushNotificationsSupported().then((isSupported) => {
                store.setState({ notificationsSupported: isSupported });
                subscriptionChangedListener(store);

                if (isSupported) {
                    if (helper.initSubscriptions) {
                        helper
                            .initSubscriptions()
                            .then(() => getEventNotifications(store, helper));
                    } else {
                        getEventNotifications(store, helper);
                    }

                    helper.onPermissionChanged((isEnabled) => {
                        if (isEnabled) getEventNotifications(store, helper);
                        else eventNotificationsReceived(store, []);
                    });
                }
            });
        })
        .catch((err) => console.error(err));
};

export const subscribeToEvent = (store, eventId) => {
    const { config } = store.getState();
    if (!enabledNotifications(store)) return;

    getHelper(store).then((helper) => {
        helper
            .subscribe(eventId)

            .then((eventTags) => {
                notifySubscriptions(
                    eventTags,
                    config.subscriptionChangedEventName
                );
                showEventNotifyModal(store, true);
            })
            .catch((err) => {
                if (err === "DENIED") showPermissionAlert(store, true);

                console.error("Could not subscribe to event " + eventId);
                console.error(err);
            });
    });
};

export const unsubscribeToEvent = (store, eventId) => {
    const { config } = store.getState();
    if (!enabledNotifications(store)) return;

    getHelper(store).then((helper) => {
        helper
            .unsubscribe(eventId)
            .then((eventTags) => {
                notifySubscriptions(
                    eventTags,
                    config.subscriptionChangedEventName
                );
            })
            .catch((err) => {
                console.error("Could not unsubscribe to event " + eventId);
                console.error(err);
            });
    });
};

